export const vod_video_help_topbar_button = 'vod:video:help-topbar-button';
export const help_modal_close_button = 'help:modal:close-button';
export const vod_video_upload_open_modal = 'vod:video-upload:open-modal';
export const vod_video_upload_close_modal = 'vod:video-upload:close-modal';
export const vod_video_upload = 'vod:video-upload';
export const vod_video_image_upload = 'vod:image-upload';
export const vod_ai_image_to_video_generate = 'vod:ai-image-to-video:generate';
export const vod_video_delete_open_modal = 'vod:video-delete:open-modal';
export const vod_video_delete_close_modal = 'vod:video-delete:close-modal';
export const vod_video_delete = 'vod:video-delete';
export const vod_video_publish = 'vod:video-publish';
export const vod_video_unpublished = 'vod:video-unpublished';
export const vod_video_edit = 'vod:video-edit';
export const vod_video_edit_settings = 'vod:video-edit:settings';
export const vod_video_edit_undo = 'vod:video-edit:undo';
export const vod_video_edit_save = 'vod:video-edit:save';
export const vod_video_list_item = 'vod:video-list-item';
export const vod_import_show_open_modal = 'vod:import-show:open-modal';
export const vod_import_show_close_modal = 'vod:import-show:close-modal';
export const vod_import_show_save_as_new = 'vod:import-show:save-as-new';
export const vod_import_click = (source) => `vod:import:${source}`;
export const vod_connect_click = (platform, sourceTab) => (sourceTab && sourceTab !== platform ? `vod:connect:${sourceTab}:${platform}` : `vod:connect:${platform}`);
export const vod_import_from_instagram = 'vod:import-from-instagram';
export const vod_import_instagram_click_tab = (tab) => `vod:import-instagram:click-tab:${tab}`;
export const vod_import_instagram_click_search_hashtag = 'vod:import-instagram:click-search-hashtag';
export const vod_video_add_tag = 'vod:video-add-tag';
export const vod_video_remove_tag = 'vod:video-remove-tag';
export const vod_video_add_tag_open_modal = 'vod:video-add-tag:open-modal';
export const vod_video_toggle_audio = 'vod:video-toggle-audio:confirm';
export const vod_video_add_tag_close_modal = 'vod:video-add-tag:close-modal';
export const vod_product_help_topbar_button = 'vod:product:help-topbar-button';
export const vod_product_add_open_modal = 'vod:product-add:open-modal';
export const vod_product_add_close_modal = 'vod:product-add:close-modal';
export const vod_product_add = 'vod:product-add';
export const vod_distribution_help_topbar_button = 'vod:distribution:help-topbar-button';
export const vod_distribution_add_open_modal = 'vod:distribution-add:open-modal';
export const vod_distribution_add_close_modal = 'vod:distribution-add:close-modal';
export const vod_distribution_add = 'vod:distribution-add';
export const vod_distribution_container_add = 'vod:distribution-container-add';
export const vod_get_started_guide_me = 'vod:get-started:guide-me';
export const vod_get_started_skip_invite = 'vod:get-started:skip-invite';
export const vod_get_started_step = (step) => `vod:get-started:${step}`;
export const vod_get_started_action = (action) => `vod:get-started-action:${action}`;
export const vod_get_started_step_back = (page) => `vod-trial-modal:step-back:${page}`;
export const vod_get_started_product_selection = (product, action) => `vod-trial-modal:${product}:${action}`;
export const TranslationsHelpTopbarButton = 'translations:help-topbar-button';
export const TranslationsOpenDrawer = 'translations:open-language-drawer';
export const TranslationsOpenLanguage = 'translations:open-language';
export const TranslationsLocalePublish = 'translations:locale:publish';
export const TranslationsLocaleEdit = 'translations:locale:edit';
export const TranslationsLocaleDelete = 'translations:locale:delete';
export const TranslationsLocaleCreate = 'translations:locale:create';
export const TranslationsLocaleOpen = 'translations:locale:open';
export const TranslationsLocaleCustomize = 'translations:locale:customize';
export const TranslationsLocaleDefault = 'translations:locale:default';
export const TranslationsLocaleLabelOpenScreenshotModal = 'translations:locale-label:open-screenshot-modal';
export const TranslationsLocaleLabelCloseScreenshotModal = 'translations:locale-label:close-screenshot-modal';
export const TranslationsLocaleLabelReset = 'translations:locale-label:reset';
export const ClientUserAction = (action) => `client-user:${action}`;
export const vod_insights_help_topbar_button = 'vod:insights:help-topbar-button';
export const live_insights_help_topbar_button = 'live:insights:help-topbar-button';
export const chat_insights_help_topbar_button = 'chat:insights:help-topbar-button';
export const embeddable_insights_select_tab = (tab) => `embeddable:select-tab:${tab}`;
export const stats_shows_list_select_tab = (tab) => `stats-shows-list:select-tab:${tab}`;
export const shows_moderate_help_button_actions = 'shows:moderate:help-button-actions';
export const LanguageSelectorOpenModal = 'language-selector:open-modal';
export const LanguageSelectorBrowserLanguage = (language) => `language-selector:browser-language:${language}`;
export const LanguageSelectorSelectLanguage = (language) => `language-selector:select-language:${language}`;
export const IntegrationsInstagramConnect = 'integrations:instagram:connect';
export const product_feed_list_item = 'product-feed:feed-list-item';
export const product_feed_help_topbar_button = 'product-feed:help-topbar-button';
export const product_feed_create_new_button = 'product-feed:create-new-button';
export const product_feed_create_empty_button = 'product-feed:create-empty-button';
export const product_feed_drawer_close = 'product-feed:drawer-close';
export const product_feed_authenticate_form_next = 'product-feed:authenticate-form-next';
export const product_feed_authenticate_form_authenticate = 'product-feed:authenticate-form-authenticate';
export const product_feed_authenticate_form_connect = 'product-feed:authenticate-form-connect';
export const product_feed_authenticate_form_update = 'product-feed:authenticate-form-update';
export const product_feed_authenticate_change_auth = 'product-feed:authenticate-change-auth';
export const product_feed_basic_settings_form_previous = 'product-feed:basic-settings-form-previous';
export const product_feed_attribute_mapping_form_previous = 'product-feed:attribute-mapping-form-previous';
export const product_feed_product_preview_form_previous = 'product-feed:product-preview-form-previous';
export const product_feed_product_preview_form_save = 'product-feed:product-preview-form-save';
export const product_feed_edit_tab_switch = 'product-feed:edit-tab-switch';
export const product_feed_edit_close_sidebar = 'product-feed:edit-close-sidebar';
export const product_feed_edit_delete_button = 'product-feed:edit-delete-button';
export const product_feed_edit_undo_button = 'product-feed:edit-undo-button';
export const product_feed_edit_save_button = 'product-feed:edit-save-button';
export const product_feed_delete_close_modal = 'product-feed:delete-close-modal';
export const product_feed_delete_confirm = 'product-feed:delete-confirm';
export const product_feed_delete_cancel = 'product-feed:delete-cancel';
export const product_feed_delete_multiple = 'product-feed:delete-multiple';
export const product_feed_list_edit_menu = 'product-feed:list-edit-menu';
export const product_feed_list_delete_menu = 'product-feed:list-delete-menu';
export const vod_ai_product_tagging_promo_connect_feed = 'ai-product-tagging-promo:connect-feed';
export const vod_ai_product_tagging_promo_try_it_out = 'ai-product-tagging-promo:try-it-out';
export const vod_ai_product_tagging_promo_view_feed_status = 'ai-product-tagging-promo:view-feed-status';
export const vod_ai_product_tagging_promo_learn_more = 'ai-product-tagging-promo:learn-more';
export const vod_ai_product_tagging_promo_dismiss = 'ai-product-tagging-promo:dismiss';
